import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import RateUsPageTitle from "./RateUsPageTitle";
import { RateUsSection } from "..";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const RateUs = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("rateUsTitle");
  }, [t]);

  return (
    <>
      <Header />
      <Main>
        <RateUsPageTitle />
        <RateUsSection />
      </Main>
      <Footer />
    </>
  );
};

export default RateUs;
